module.exports = __webpack_public_path__ + "media/images/no_animation_drive_preview-d69fab0e.png";